import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  IconButton,
  Paper,
} from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import ClearIcon from '@mui/icons-material/Clear';

const ChatComponent = ({ data, queryApi }) => {
  const [chatMessages, setChatMessages] = useState([]);
  const [chatMessage, setChatMessage] = useState('');
  const [chatOpen, setChatOpen] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);

  const handleChatSubmit = async () => {
    if (!chatMessage.trim()) return;
    setChatLoading(true);
    try {
      const response = await queryApi(chatMessage, JSON.stringify(data));
      setChatMessages((prev) => [
        ...prev,
        { sender: 'user', text: chatMessage },
        { sender: 'system', text: response.data.reply },
      ]);
      setChatMessage('');
    } catch (error) {
      console.error('Error querying chat data:', error);
      setChatMessages((prev) => [
        ...prev,
        { sender: 'user', text: chatMessage },
        { sender: 'system', text: 'Failed to fetch a response. Please try again.' },
      ]);
    } finally {
      setChatLoading(false);
    }
  };

  const handleClearChat = () => {
    setChatMessages([]);
  };

  const handleChatOpen = () => {
    setChatOpen(true);
    setChatMessage('');
  };

  return (
    <>
      {chatOpen && (
        <Paper
          elevation={3}
          sx={{
            position: 'fixed',
            bottom: 80,
            left: 320,
            width: 600,
            maxHeight: 400,
            overflowY: 'auto',
            p: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Chat</Typography>
            <IconButton onClick={() => setChatOpen(false)}>
              <ClearIcon />
            </IconButton>
          </Box>
          <Box mb={2}>
            {chatMessages.map((msg, index) => (
              <Typography
                key={index}
                sx={{
                  textAlign: msg.sender === 'user' ? 'right' : 'left',
                  backgroundColor: msg.sender === 'user' ? '#e3f2fd' : '#f1f8e9',
                  borderRadius: 1,
                  p: 1,
                  mb: 1,
                }}
              >
                {msg.text}
              </Typography>
            ))}
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <TextField
              fullWidth
              size="small"
              placeholder="Query crash data"
              value={chatMessage}
              onChange={(e) => setChatMessage(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') handleChatSubmit();
              }}
            />
            <Button
              variant="contained"
              onClick={handleChatSubmit}
              disabled={chatLoading}
            >
              {chatLoading ? <CircularProgress size={24} /> : 'Send'}
            </Button>
          </Box>
          <Button onClick={handleClearChat} color="error" sx={{ mt: 2 }} fullWidth>
            Clear Chat
          </Button>
        </Paper>
      )}
      <IconButton
        onClick={handleChatOpen}
        sx={{ position: 'fixed', bottom: 20, left: 320 }}
        color="primary"
      >
        <ChatIcon fontSize="large" />
      </IconButton>
    </>
  );
};

export default ChatComponent;
